// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#__nuxt .amp-layout__wrapper .layout-video-banner__wrapper{padding:24px 16px}", ""]);
// Exports
module.exports = exports;
